const AXIS_EDGES = { row: ['left', 'right'], vertical: ['top', 'bottom'] };

// The axis comes from the computed flex-direction, so drops match what every preview shows.
export function readFlow(container) {

  const direction = window.getComputedStyle(container).flexDirection;
  let axis = 'vertical';

  if (direction.indexOf('row') === 0) {
    axis = 'row';
  }

  return { axis, reversed: direction.indexOf('reverse') !== -1, canWrap: false };

}

export function findParentFlow(element) {

  const cell = element.parentElement;

  if (cell === null || cell.classList.contains('layout-cell') === false) {
    return { axis: 'vertical', reversed: false, canWrap: false };
  }

  return readFlow(cell.parentElement);

}

export function findCells(element) {

  const container = element.querySelector(':scope > .editor-element > .layout-wrapper > .layout-container');
  const cells = [];

  if (container === null) {
    return { container, cells };
  }

  for (let index = 0; index < container.children.length; index++) {
    if (container.children[index].classList.contains('layout-cell') === true) {
      cells.push(container.children[index]);
    }
  }

  return { container, cells };

}

export function readRectangles(cells) {

  const rectangles = [];

  for (let index = 0; index < cells.length; index++) {
    rectangles.push(cells[index].getBoundingClientRect());
  }

  return rectangles;

}

export function findEdges(flow) {

  const edges = AXIS_EDGES[flow.axis];

  if (flow.reversed === true) {
    return { leading: edges[1], trailing: edges[0] };
  }

  return { leading: edges[0], trailing: edges[1] };

}
